export default __webpack_public_path__ + "static/media/vectorpaint.dd031db1.svg";